<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="max-width-25per pr-0">
              <v-spacer></v-spacer>
              Human Resources:
            </v-card-title>
            <v-card-text class="vh-80">
              <v-data-table
                dense
                hide-default-header
                :headers="headers"
                :items="adminHumanResourcesSettingsItems"
                class="max-width-50vw border-thin mx-25per mt-8"
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:[`item.Name`]="{ item }">
                    <span class="subtitle-1"> {{ item.Name }} </span>
                </template>
                <template v-slot:[`item.Actions`]="{ item }">
                  <v-btn color="primary" outlined small @click="manageClick(item)">Manage</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <EmailsManager
      v-model="showEmailTempaltesDialog"
      @showEmailsEditor="showEmailEditor"
    />
    <PolicyLibrary
      v-model="showPolicyLibraryDialog"
      @showPolicyEditor="showPolicyEditor"
    />
    <DaysOffManager
      v-model="showDayOffDialog"
      :daysoff="daysoff"
    />
    <CompensationsManager
      v-if="HRorFinancierRole"
      v-model="showCompensationsDialog"
    />
    <EmployeeStatusesManager
      v-model="employeeStatusesManagerDialog"
    />
    <DepartmentsManager
      v-model="departmentsManagerDialog"
    />
    <EmployeeSkillsManager
      v-model="showEmployeeSkills"
    />
    <CompensationTypesManager
      v-if="showBenefitCompensationTypesManager"
      v-model="showBenefitCompensationTypesManager"
    />
    <CompensationRefundTypesManager
      v-if="showRefundCompensationTypesManager"
      v-model="showRefundCompensationTypesManager"
    />
    <MilitaryCategoriesManager
      v-if="showMilitaryCategoriesManager"
      v-model="showMilitaryCategoriesManager"
    />
      <DefermentTypeManager
      v-if="showDefermentTypeManager"
      v-model="showDefermentTypeManager"
    />
    <LAndDApprovers
      v-if="showLAndDApproversManager"
      v-model="showLAndDApproversManager"
    />
    <SupportContactsManager
      v-if="showSupportContactsManager"
      v-model="showSupportContactsManager"
     />
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'AdminHumanResources',
  components: {
    EmailsManager: () => import('@/components/email_editor/EmailsManager.vue'),
    PolicyLibrary: () => import('@/components/policy_library/PolicyLibrary.vue'),
    DaysOffManager: () => import('@/components/days_off/DaysOffManager.vue'),
    CompensationsManager: () => import('@/components/payroll/CompensationsManager.vue'),
    EmployeeStatusesManager: () => import('@/components/global/EmployeeStatusesManager.vue'),
    DepartmentsManager: () => import('@/components/global/DepartmentsManager.vue'),
    EmployeeSkillsManager: () => import('@/components/employee_skills/EmployeeSkillsManager.vue'),
    CompensationTypesManager: () => import('@/components/admin/compensation_types/CompensationTypesManager.vue'),
    CompensationRefundTypesManager: () => import('@/components/admin/compensation_types/CompensationRefundTypesManager.vue'),
    MilitaryCategoriesManager: () => import('@/components/admin/military_categories/MilitaryCategoriesManager.vue'),
    DefermentTypeManager: () => import('@/components/admin/military_categories/DefermentTypeManager.vue'),
    LAndDApprovers: () => import('@/components/admin/l_and_d_approvers/l_and_d_approvers.vue'),
    SupportContactsManager: () => import('@/components/admin/support_contacts/SupportContactsManager.vue')
  },
  data () {
    return {
      rolesOfCurrentUser: [],
      headers: [
        {
          text: 'Name',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          width: '90%'
        },
        {
          text: '',
          value: 'Actions',
          class: 'px-2 text-no-wrap',
          width: '10%',
          align: 'right'
        }
      ],
      adminHumanResourcesSettingsItems: [
        { Name: 'Compensations' },
        { Name: 'Days off' },
        { Name: 'Departments' },
        { Name: 'Email Editor' },
        { Name: 'Employee Positions' },
        { Name: 'Policy Library' },
        { Name: 'Employee Skills' },
        { Name: 'Benefit Compensation Types' },
        { Name: 'Refund Compensation Types' },
        { Name: 'Military Categories' },
        { Name: 'Deferment Types' },
        { Name: 'L&D Approvers' },
        { Name: 'Support Contacts' }
      ],
      departmentsManagerDialog: false,
      currentEmailTemplate: null,
      emailEditorDialog: false,
      manageEmailTemplatesDialog: false,
      employeeStatusesManagerDialog: false,
      managePolicyLibrary: false,
      policyEditorDialog: false,
      currentPolicy: null,
      showDayOffDialog: false,
      showCompensationsDialog: false,
      daysoff: [],
      employee_skills: [],
      showEmployeeSkills: false,
      showBenefitCompensationTypesManager: false,
      showRefundCompensationTypesManager: false,
      showMilitaryCategoriesManager: false,
      showDefermentTypeManager: false,
      showLAndDApproversManager: false,
      showSupportContactsManager: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    HRorFinancierRole () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (this.rolesOfCurrentUser[i].RoleName === 'HR' || this.rolesOfCurrentUser[i].RoleName === 'financier') {
          res = true
          break
        }
      }
      return res
    },
    showEmailTempaltesDialog: {
      get () {
        return this.manageEmailTemplatesDialog
      },
      set (val) {
        if (!val) this.currentEmailTemplate = null
        this.manageEmailTemplatesDialog = val
      }
    },
    showPolicyLibraryDialog: {
      get () {
        return this.managePolicyLibrary
      },
      set (val) {
        if (!val) this.currentPolicy = null
        this.managePolicyLibrary = val
      }
    }
  },
  mounted () {
    if (!this.rolesOfCurrentUser.length) {
      this.getRolesOfCurrentUser()
    }
  },
  methods: {
    getRolesOfCurrentUser () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openEmployeeStatusList () {
      this.employeeStatusesManagerDialog = true
    },
    openDepartmentsList () {
      this.departmentsManagerDialog = true
    },
    showEmailEditor (e) {
      this.currentEmailTemplate = e
      this.emailEditorDialog = true
    },
    showPolicyEditor (e) {
      this.currentPolicy = e
      this.policyEditorDialog = true
    },
    getDaysOff () {
      this.axios.get('/api/daysoff', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.daysoff = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openDaysOffManager () {
      this.getDaysOff()
      this.showDayOffDialog = true
    },
    openEmployeeSkillsManager () {
      this.showEmployeeSkills = true
    },
    manageClick (item) {
      switch (item.Name) {
        case 'Email Editor' :
          this.showEmailTempaltesDialog = true
          break
        case 'Policy Library' :
          this.showPolicyLibraryDialog = true
          break
        case 'Days off' :
          this.openDaysOffManager()
          break
        case 'Compensations' :
          this.showCompensationsDialog = true
          break
        case 'Employee Positions' :
          this.openEmployeeStatusList()
          break
        case 'Departments' :
          this.openDepartmentsList()
          break
        case 'Employee Skills' :
          this.openEmployeeSkillsManager()
          break
        case 'Benefit Compensation Types' :
          this.showBenefitCompensationTypesManager = true
          break
        case 'Refund Compensation Types' :
          this.showRefundCompensationTypesManager = true
          break
        case 'Military Categories' :
          this.showMilitaryCategoriesManager = true
          break
        case 'Deferment Types' :
          this.showDefermentTypeManager = true
          break
        case 'L&D Approvers' :
          this.showLAndDApproversManager = true
          break
        case 'Support Contacts' :
          this.showSupportContactsManager = true
          break
      }
    }
  }
}
</script>
<style lang="scss">
  .max-width-50vw {
    max-width: 50vw;
  }
  .border-thin {
    border: thin solid #9e9e9e
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    border-bottom: thin solid #9e9e9e
  }
  .mx-25per {
    margin-left: 25%;
    margin-right: 25%;
  }
  .vh-80 {
    height: 80vh;
  }
  tr {
    height: 40px !important;
  }
  .max-width-25per {
    max-width: 25%;
  }
</style>
